import type { HTMLAttributes, PropsWithChildren } from 'react';
import type { TextStyleValue } from '@elfsight/configurator-contracts';
import { Typography } from '@elfsight/widget-ui';
import { createReadableClass } from '@elfsight/widget-utils';
import { CLASS_COMPONENT, STYLE_DEFAULTS } from '../../common';

type TextProps = {
  color?: string;
  error?: boolean;
  textStyle?: Partial<TextStyleValue>;
  className?: string;
};

export function Text({
  color,
  error,
  textStyle = { fontSize: STYLE_DEFAULTS.fontSize },
  children,
  className,
  ...forwardingProps
}: PropsWithChildren<TextProps & HTMLAttributes<HTMLDivElement>>) {
  return (
    <Typography
      className={createReadableClass(
        {
          component: CLASS_COMPONENT,
          element: 'text-block'
        },
        [className]
      )}
      color={error ? STYLE_DEFAULTS.errorColor : color || 'inherit'}
      textStyle={{
        ...STYLE_DEFAULTS,
        ...textStyle
      }}
      {...forwardingProps}
    >
      {children}
    </Typography>
  );
}
